import request from '@/utils/request'

//更新pv点击数
export function updatePvNum(itemKey) {
    let pvForm = {};
    pvForm.itemKey=itemKey;
    return request({
        url: '/web/itempv/updateRzsqsx',

        method: 'post',
        data: pvForm
    })
}

//获取pv
export function getPv(itemKey) {
    let pvForm = {};
    pvForm.itemKey=itemKey;
    return request({
        url: '/web/itempv/getPv',
        method: 'post',
        data: pvForm
    })
}

